module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    attrs: {
      "to": "/tryouts",
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-pencil"
  }), _c('span', [_vm._v("Tryout")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b0bde4ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tryout/Navigation.vue
// module id = 1387
// module chunks = 0